const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Company Integrations Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('CompanyIntegrations', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/v3/companyintegrations/:subresource', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    status: {params: {subresource: 'status'}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false}
  });
}]);